import React from 'react';
import { Network, Cloud, Shield, Server, Smartphone, Headphones } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from './ui/card';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: Network,
      title: 'Network Infrastructure',
      description: 'Design, implementation, and maintenance of robust network systems',
      link: '/services'
    },
    {
      icon: Cloud,
      title: 'Microsoft 365',
      description: 'Complete Microsoft 365 deployment, migration, and security',
      link: '/microsoft-365'
    },
    {
      icon: Shield,
      title: 'Cybersecurity',
      description: 'Protect your business with comprehensive security solutions',
      link: '/cybersecurity'
    },
    {
      icon: Smartphone,
      title: 'Apple MDM',
      description: 'Mobile Device Management with Apple Business Manager & Mosyle',
      link: '/mdm'
    },
    {
      icon: Server,
      title: 'Server Management',
      description: 'Reliable server administration and maintenance services',
      link: '/services'
    },
    {
      icon: Headphones,
      title: 'IT Support',
      description: 'Dedicated technical support when you need it most',
      link: '/managed-it'
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-cyan-500 uppercase tracking-wide mb-2">
            What We Offer
          </p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our IT Services</h2>
          <p className="text-lg text-gray-600">
            Comprehensive technology solutions for organizations with 5–50 users
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter>
                  <Link to={service.link}>
                    <Button variant="link" className="text-blue-600 hover:text-blue-700 p-0">
                      Learn more →
                    </Button>
                  </Link>
                </CardFooter>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;